"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSContactInformationComponent = void 0;
const operators_1 = require("rxjs/operators");
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const generic_content_service_1 = require("../../../shared/services/generic.content.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const lodash_1 = require("lodash");
const roles_helper_service_1 = require("../../services/roles-helper.service");
const underscore_1 = require("underscore");
const constants_1 = require("../../../shared/constants");
class CSContactInformationComponent {
    constructor(accountDetailService, accountService, genericContentService, rolesService) {
        this.accountDetailService = accountDetailService;
        this.accountService = accountService;
        this.genericContentService = genericContentService;
        this.rolesService = rolesService;
        this.isSecondary = false;
        this.isProspect = false;
        this.isPrepaidAcc = false;
        this.isUpdateAccountInfoAllowed = true;
        this.roles = constants_1.UserRole;
    }
    ngOnInit() {
        this.getAccountInformationDetails();
        this.showForm = true;
        this.getErrorMessage();
    }
    getAccountInformationDetails() {
        this.disabledEdit = true;
        this.loader = true;
        this.error = null;
        this.feErrorMsg = null;
        this.emailConfirmed = true;
        this.sentVerificationEmail = false;
        this.accountDetailService.getAccountContactInformation().pipe(operators_1.finalize(() => {
            this.accountService.getAccountDetails(this.isAccountCache).subscribe((res) => {
                var _a, _b;
                this.disabledEdit = false;
                this.mdnList = res.subscription;
                this.isProspect = res.prospectProfile;
                this.emailAddress = res.emailAddress;
                this.isPrepaidAcc = res.advancePayAccount;
                this.isBusiness = res.businessAccount;
                const subscription = res.subscription;
                const primarySub = underscore_1.find(subscription, function (sub) {
                    return sub.primarySubOnAccount != null;
                });
                if (primarySub !== undefined) {
                    this.primaryMobileNumber = primarySub.mobileNumber;
                    this.primarySubId = primarySub.subscriptionId;
                    this.contactInfo.mobileNumber = this.primarySubId;
                    if (res.emailAddress === undefined || res.emailAddress == null) {
                        this.contactInfo.email = primarySub.emailAddress;
                    }
                }
                if (this.isBusiness) {
                    this.setUpdateAccountInfoPermission();
                }
                if (!res.emailVerified && res.profileType === 'PRIMARY') {
                    this.emailConfirmed = false;
                }
                if (res.profileType === 'SECONDARY') {
                    this.isSecondary = true;
                }
                this.contactInfo.billingAddress = ((_b = (_a = this.contactInfo) === null || _a === void 0 ? void 0 : _a.billingAddress) === null || _b === void 0 ? void 0 : _b.addressLine1) ? this.contactInfo.billingAddress : res.billingAddress;
                this.loader = false;
            });
        })).subscribe((info) => {
            this.contactInfo = info;
            this.isPrepaidAccountPinUser = this.contactInfo.prepaidPinStatus;
            this.tempContactInfo = lodash_1.cloneDeep(this.contactInfo);
            if (this.contactInfo.billingAddress === undefined) {
                this.contactInfo.billingAddress = {};
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    submitContactInformation(value) {
        this.loader = true;
        this.error = null;
        this.feErrorMsg = null;
        this.accountDetailService.validateContactInformation(value, this.isPrepaidAcc, this.isBusiness, this.isUpdateAccountInfoAllowed)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.error = null;
            this.isAccountCache = false;
            this.getAccountInformationDetails();
            this.showForm = true;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    updateUserIdInformation(value) {
        this.loader = true;
        this.error = null;
        this.feErrorMsg = null;
        this.accountDetailService.submitUserIdInfo(value)
            .subscribe((res) => {
            this.loader = false;
            this.updateMessage = true;
            this.error = null;
            this.isAccountCache = true;
            this.getAccountInformationDetails();
            this.showUserIdForm = false;
            // this.showForm = true;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.error = null;
        this.feErrorMsg = null;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    tooltipForPrimaryAccount() {
        this.genericContentService.getGenericContent('genericContentPrimaryAccount').subscribe((data) => {
            this.primaryAccountContentData = data;
        }, (err) => {
            this.error = err;
        });
    }
    convertPasswordToText(parentInput) {
        this.showPasswords = !this.showPasswords;
        const element = document.getElementsByClassName(parentInput);
        for (let i = 0; i < element.length; i++) {
            if (this.showPasswords) {
                element[i].type = 'text';
            }
            else {
                element[i].type = 'password';
            }
        }
        return this.showPasswords ? 'text' : 'password';
    }
    togglePassword(childInput, parentInput) {
        const textIcon = '/resources/images/mmx-icon-eye-closed.png';
        const passIcon = '/resources/images/mmx-icon-eye-open.png';
        const logo = document.getElementsByClassName(childInput)[0];
        const currentPasswordType = this.convertPasswordToText(parentInput);
        logo.src = currentPasswordType === 'text' ? textIcon : passIcon;
    }
    setUpdateAccountInfoPermission() {
        const roles = [this.roles.ACCOUNT_PRIMARY];
        this.isUpdateAccountInfoAllowed = this.rolesService.getRolesPermission(roles);
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    checkButtonStatus() {
        let disableButton = false;
        if (!this.isPrepaidAccountPinUser) {
            disableButton = !this.accountPassword && !this.accountConfirmPassword && this.contactInfo.mobileNumber === this.primarySubId;
        }
        else {
            disableButton = !this.accountPassword && !this.accountConfirmPassword && !this.prepaidAccountPin && this.contactInfo.mobileNumber === this.primarySubId;
        }
        if (this.accountPassword && this.accountConfirmPassword) {
            return disableButton || (this.accountPassword.trim() !== this.accountConfirmPassword.trim());
        }
        else {
            return disableButton || (this.accountPassword && !this.accountConfirmPassword) || (!this.accountPassword && this.accountConfirmPassword);
        }
    }
    clearfields() {
        this.accountPassword = '';
        this.accountConfirmPassword = '';
        this.prepaidAccountPin = '';
    }
}
exports.CSContactInformationComponent = CSContactInformationComponent;
//# sourceMappingURL=contactinformation.component.js.map